import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/message-reaction.ts
const spaceReactionActorSchema = z$1.object({
	profileId: z$1.string().min(1),
	displayName: z$1.string(),
	profileKind: z$1.enum(["human", "agent"])
});
const spaceReactionGroupSchema = z$1.object({
	emoji: z$1.string().min(1).max(64),
	label: z$1.string(),
	count: z$1.number().int().positive(),
	reactedByMe: z$1.boolean(),
	actors: z$1.array(spaceReactionActorSchema),
	actorsHasMore: z$1.boolean()
});
const spaceMessageReactionsSchema = z$1.object({
	version: z$1.number().int().nonnegative(),
	groups: z$1.array(spaceReactionGroupSchema)
});
const getSpaceMessageReactionsInputSchema = z$1.object({
	spaceId: z$1.string().trim().min(1),
	signalId: z$1.string().trim().min(1),
	emoji: z$1.string().min(1).max(64).optional(),
	afterProfileId: z$1.string().min(1).max(256).optional()
});
const setSpaceMessageReactionInputSchema = z$1.object({
	spaceId: z$1.string().trim().min(1),
	signalId: z$1.string().trim().min(1),
	emoji: z$1.string().min(1).max(64),
	active: z$1.boolean()
});
const getSpaceMessageReactionsResponseSchema = z$1.object({
	signalId: z$1.string(),
	reactions: spaceMessageReactionsSchema,
	actors: z$1.array(spaceReactionActorSchema).optional(),
	nextCursor: z$1.string().nullable().optional()
});
//#endregion
export { getSpaceMessageReactionsInputSchema, getSpaceMessageReactionsResponseSchema, setSpaceMessageReactionInputSchema, spaceMessageReactionsSchema, spaceReactionActorSchema, spaceReactionGroupSchema };

//# sourceMappingURL=message-reaction.js.map